import moment from 'moment';

const compareDates = (departure, arrival) =>
  moment(departure).isSame(moment(arrival), 'date');

export default compareDates;
